import { Alert, Button, Card, Col, Collapse, Divider, Form, InputNumber, Row, Segmented, Space, Steps, theme, Tooltip, Typography } from 'antd'
import React, { useMemo, useState } from 'react'
import { useLanguage } from 'src/providers/LanguageProvider';

import { InfoCircleOutlined, TeamOutlined, ShopOutlined } from '@ant-design/icons';
const description = 'This is a description.';
const { Panel } = Collapse;
type Props = {
  selectedId: number;
  onClick: (id: number) => void;
  employeeCount: number | null;
  setEmployeeCount: (n: number | null) => void;
  b2bWebshopEnabled: boolean | null;                 // NEW
  setB2bWebshopEnabled: (v: boolean | null) => void; // NEW
};

const SelectProduct = ({
  selectedId,
  onClick,
  employeeCount,
  setEmployeeCount,
  b2bWebshopEnabled,
  setB2bWebshopEnabled
}: Props) => {
  const { t } = useLanguage();
  const { token } = theme.useToken();

  return (
    <>
      <Alert
        banner
        type="info"
        message={t('SETUP_WIZARD_SELECT_PRODUCT_ALERT')}
        style={{ marginBottom: 20 }}
      />

      <Row>
        {/* Ürün Kartı */}
        <Col lg={6} md={8} sm={12} xs={24} style={{ padding: 10 }}>
          <Card
            hoverable
            onClick={() => onClick(13)}
            style={{ border: selectedId === 1 ? `1px solid ${token.colorPrimaryActive}` : '' }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
              <img
                src="https://api.dicebear.com/8.x/shapes/svg?seed=13"
                alt="Product 1"
                style={{ height: 128, borderRadius: '50%' }}
              />
            </div>

            <Typography.Title level={5} style={{ textAlign: 'center', marginTop: 10 }}>
              W Parts-Soft ERP
            </Typography.Title>

            <Typography.Paragraph style={{ textAlign: 'center' }}>
              {t('SETUP_WIZARD_PRODUCT_ERP_DESC')}
            </Typography.Paragraph>
          </Card>
        </Col>

        {/* Sağ taraf: Soru Kartları */}
        {selectedId === 13 ? (
          <Col lg={18} md={16} sm={24} xs={24} style={{ padding: 10 }}>
            <Card styles={{


            }}
              title={
                <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <InfoCircleOutlined />
                  {t?.('SETUP_WIZARD_BRANCH_SETTINGS_TITLE') || 'Şube Ayarları'}
                </span>
              }
         
              style={{
                border: `1px solid ${token.colorBorderSecondary}`,
                boxShadow: token.boxShadowTertiary,
                marginBottom: 16,
                height: '100%'
              }}
            >
              <Typography.Paragraph style={{ marginBottom: 0, opacity: 0.85 }}>
                {t?.('SETUP_WIZARD_BRANCH_SETTINGS_DESC') ||
                  'Aşağıdaki bilgileri girin; personel planlaması, lisans boyutlandırma ve B2B modül kurulumu için kullanılacaktır.'}
              </Typography.Paragraph>

              <Divider style={{ margin: '16px 0' }} />

              <Form layout="vertical" requiredMark={false}>
                <Row gutter={[16, 8]}>
                  {/* ÇALIŞAN SAYISI */}
                  <Col xs={24} md={12}>
                    <Form.Item
                      label={
                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <TeamOutlined />
                          {t?.('SETUP_WIZARD_EMPLOYEE_COUNT_LABEL') || 'Çalışan sayısı'}
                          <Tooltip
                            title={
                              t?.('SETUP_WIZARD_BRANCH_EMP_COUNT_HINT') ||
                              'Yaklaşık sayı girebilirsiniz; daha sonra güncelleyebilirsiniz.'
                            }
                          >
                            <InfoCircleOutlined style={{ opacity: 0.7 }} />
                          </Tooltip>
                        </span>
                      }
                      tooltip={t?.('SETUP_WIZARD_EMPLOYEE_COUNT_TOOLTIP') || 'En az 1, en fazla 5.000'}
                      required
                      validateStatus={
                        employeeCount === null ? undefined : employeeCount < 1 ? 'error' : 'success'
                      }
                      help={
                        employeeCount !== null && employeeCount < 1
                          ? t?.('SETUP_WIZARD_EMPLOYEE_COUNT_ERROR') ||
                          'Lütfen 1 veya daha büyük bir sayı girin.'
                          : undefined
                      }
                    >
                      <InputNumber
                        placeholder={t?.('SETUP_WIZARD_EMPLOYEE_COUNT_PLACEHOLDER') || 'Örn. 24'}
                        min={1}
                        max={5000}
                        value={employeeCount ?? undefined}
                        onChange={(v) => {
                          const n = typeof v === 'number' ? v : null;
                          setEmployeeCount(n);
                        }}
                        style={{ width: '100%' }}
                        formatter={(value) =>
                          value !== undefined && value !== null
                            ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
                            : ''
                        }
                        parser={(value) => (value ? parseInt(value.replace(/\./g, ''), 10) : NaN)}
                        addonAfter={t?.('SETUP_WIZARD_PERSON_SUFFIX') || 'kişi'}
                      />
                    </Form.Item>
                    <Typography.Text type="secondary" style={{ display: 'block', marginTop: -8 }}>
                      {t?.('SETUP_WIZARD_BRANCH_EMP_COUNT_DESC') ||
                        'Bu bilgi, personel planlaması ve lisans boyutlandırması için kullanılacaktır.'}
                    </Typography.Text>
                  </Col>

                  {/* B2B WEBSHOP */}
                  <Col xs={24} md={12}>
                    <Form.Item
                      label={
                        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <ShopOutlined />
                          {t?.('SETUP_WIZARD_B2B_WEBSHOP_TITLE') ||
                            'Dahili bir B2B Webshop istiyor musunuz?'}
                          <Tooltip
                            title={
                              t?.('SETUP_WIZARD_B2B_WEBSHOP_HINT') ||
                              'B2B sipariş, fiyat listeleri ve cari/iskonto yönetimi için.'
                            }
                          >
                            <InfoCircleOutlined style={{ opacity: 0.7 }} />
                          </Tooltip>
                        </span>
                      }
                    >
                      <Segmented
                        block
                        value={
                          b2bWebshopEnabled === null
                            ? undefined
                            : b2bWebshopEnabled
                              ? 'Evet'
                              : 'Hayır'
                        }
                        onChange={(val) => {
                          if (val === 'Evet') setB2bWebshopEnabled(true);
                          else if (val === 'Hayır') setB2bWebshopEnabled(false);
                          else setB2bWebshopEnabled(null);
                        }}
                        options={[
                          { label: 'Evet', value: 'Evet' },
                          { label: 'Hayır', value: 'Hayır' }
                        ]}
                      />
                    </Form.Item>

                    {b2bWebshopEnabled ? (
                      <Typography.Text type="secondary" style={{ display: 'block', marginTop: -8 }}>
                        {t?.('SETUP_WIZARD_B2B_WEBSHOP_NOTE') ||
                          'Tercih ettiniz. Gerekli modüller kurulum adımlarına eklenecek.'}
                      </Typography.Text>
                    ) : b2bWebshopEnabled === false ? (
                      <Typography.Text type="secondary" style={{ display: 'block', marginTop: -8 }}>
                        {t?.('SETUP_WIZARD_B2B_WEBSHOP_NOTE_OFF') ||
                          'Tercih etmediniz. Daha sonra ayarlardan etkinleştirebilirsiniz.'}
                      </Typography.Text>
                    ) : (
                      <Typography.Text type="secondary" style={{ display: 'block', marginTop: -8 }}>
                        {t?.('SETUP_WIZARD_B2B_WEBSHOP_DESC') ||
                          'İsterseniz B2B müşterileriniz stok, fiyat ve siparişlerini bu portal üzerinden yönetebilir.'}
                      </Typography.Text>
                    )}
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        ) : null}
      </Row>

      {selectedId == 13 ? <>

        <Divider />


        <Collapse defaultActiveKey={['1']} >
          <Panel header={t('WHATS_MEAN_BRANCH_EMP_COUNT')} key="1">
            <p>{t('WHATS_MEAN_BRANCH_EMP_COUNT_DESC')}</p>
          </Panel>

          <Panel header={t('WHATS_MEAN_B2B_WEBSHOP')} key="2">
            <p>{t('WHATS_MEAN_B2B_WEBSHOP_DESC')}</p>
          </Panel>



        </Collapse>



      </>

        : null}



    </>
  );
};



export default SelectProduct;